import React from "react";
import { useSelector } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";
import FetchChatDetailsButton from "components/ChatGPT/FetchChatDetailsButton";
import SeeWhatWasSentUsage from "components/ChatGPT/SeeWhatWasSentUsage";
const MessageCosts = ({ message, isFetchingDetails, updateFetchingId }) => {
    const showTokens = useSelector((state) => chatGPTReducer.getShowTokens(state));
    if (!showTokens) {
        return React.createElement(React.Fragment, null);
    }
    if (message?.contentGenerationIds && message.contentGenerationIds.length > 0) {
        return (React.createElement("div", null,
            React.createElement(ChatUsageDetails, { contentGenerationIds: message?.contentGenerationIds, accountId: message?.contentGenerationAccount, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId })));
    }
    return React.createElement(React.Fragment, null);
};
const ChatUsageDetails = ({ contentGenerationIds, accountId, isFetchingDetails, updateFetchingId }) => {
    const chatMessageDetailsKeys = useSelector((state) => chatDetailsReducer.getChatMessageDetailsKeys(state));
    return (React.createElement("div", null, contentGenerationIds?.map((id) => {
        const chatMessageDetail = useSelector((state) => chatDetailsReducer.getChatMessageDetails(state, id));
        const isLoadingId = isFetchingDetails && isFetchingDetails[String(id)] === true;
        const results = chatMessageDetail ? chatMessageDetail?.results : undefined;
        let inputTokens = 0;
        let outputTokens = 0;
        let estimatedCost = 0;
        let executionTime = 0;
        results?.forEach((result) => {
            inputTokens += result?.input_token_count;
            outputTokens += result?.output_token_count;
            estimatedCost += result?.estimated_cost;
            executionTime += result.execution_time;
        });
        const usage = {
            input_token_count: inputTokens,
            output_token_count: outputTokens,
            token_count: inputTokens + outputTokens,
            estimated_cost: estimatedCost,
            executionTime: executionTime
        };
        if (!chatMessageDetailsKeys?.includes(String(id)) || isLoadingId) {
            return (React.createElement(FetchChatDetailsButton, { id: id, accountId: accountId, buttonText: "Show Token Usage", key: "fetch_button__" + id, isFetchingDetails: isFetchingDetails, updateFetchingId: updateFetchingId }));
        }
        return React.createElement(SeeWhatWasSentUsage, { usage: usage, key: "detailed_usage__" + id });
    })));
};
export default MessageCosts;
